module.exports = __webpack_public_path__ + "static/media/cba2020_paper.21895049.png";